import React from "react";

export default function EmptyUser() {
  return (
    <div style={{ padding: "30px", textAlign: "center", marginTop: "20px"}}>
      <h1 style={{ fontSize: 22 }}>Vous n'avez aucun Adhérent associé à votre compte actuellement</h1>
    </div>
  );
}
